import React from "react";
import { FastField } from "formik";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

import RadioGroup from "../../../components/form/RadioGroup";

const SPACING = 2;

const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  width: `calc(100% + ${theme.spacing(SPACING * 2)})`,
  margin: `-${theme.spacing(SPACING)}`,
}));

const styles = {
  checkboxButton: {
    p: SPACING,
    '& input[type="radio"]': {
      cursor: "pointer",
      opacity: 0,
      height: "100%",
      width: "100%",
      position: "absolute",
      left: 0,
      right: 0,
      zIndex: 1000,
    },
    "& label": {
      height: "100%",
      width: "100%",
      display: "block",
      position: "relative",
      padding: "16px 8px",
      boxShadow: 2,
      backgroundColor: "common.white",
    },
    '& input[type="radio"]:checked + label': {
      backgroundColor: "success.light",
    },
  },
  checkboxCard: {
    height: "100%",
    position: "relative",
  },
};

function RoomTypeCheckbox(props) {
  const {
    option: { plan, name },
  } = props;
  const currency = "$";

  return (
    <Grid sx={styles.checkboxButton} size={3}>
      <Box sx={styles.checkboxCard}>
        <FastField type="radio" {...props.option} />
        <label htmlFor={name}>
          <Box
            textAlign="center"
            fontWeight="fontWeightBold"
            fontSize="h4.fontSize"
            color="text.primary"
            mb={1}
          >
            {plan.name}
          </Box>

          <Box textAlign="center" mb={1}>
            <Typography display="inline" variant="h4" color="textPrimary">
              {`${currency}${plan.amount}`}
            </Typography>
            <Typography variant="h4" display="inline" color="textPrimary">
              /mo
            </Typography>
          </Box>

          <Box textAlign="center">
            <Typography display="inline" variant="h6" color="textPrimary">
              {plan.description}
            </Typography>
          </Box>
        </label>
      </Box>
    </Grid>
  );
}

const RoomTypeCheckboxWrap = ({ children }) => <Grid container>{children}</Grid>;

const SubscriptionPlans = ({ companyPlans, ...inputProps }) => {
  const options = companyPlans.map(plan => ({
    plan: plan,
    name: `${inputProps.name}`,
    value: plan.id,
  }));

  return (
    <>
      <StyledRadioGroup
        {...inputProps}
        component={RoomTypeCheckbox}
        componentWrap={RoomTypeCheckboxWrap}
        options={options}
      />
    </>
  );
};

export default SubscriptionPlans;
